
























import { computed, defineComponent, ref } from "@vue/composition-api";
import { debounce } from "lodash-es";
import BaseInputTextarea from "@/components/BaseInputTextarea";

const REVIEW_CHARS_LIMIT = "1500";

export default defineComponent({
  name: "ReviewInput",
  components: { BaseInputTextarea },
  props: {
    sending: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const value = ref<string>("");

    const appendIcon = computed<string>(() => (!!value.value ? "sci-send" : ""));

    const inputReview = (v: string) => {
      value.value = v;
      emit("input", value.value);
    };

    const sendReview = debounce(() => {
      if (props.sending || value.value === "") {
        return;
      }
      emit("submit", () => {
        value.value = "";
      });
    }, 200);

    return {
      value,
      inputReview,
      appendIcon,
      sendReview,
      REVIEW_CHARS_LIMIT,
    };
  },
});
